import { Select as BaseSelect } from '@base-ui-components/react/select'
import { SelectContext } from './select-context'

export function SelectRoot<TValue>({
  size = 'md',
  variant = 'outline',
  ...props
}: SelectRoot.Props<TValue>) {
  return (
    <SelectContext.Provider value={{ size, variant }}>
      <BaseSelect.Root {...props} />
    </SelectContext.Provider>
  )
}

export namespace SelectRoot {
  export type Props<TValue> = BaseSelect.Root.Props<TValue> & Partial<SelectContext>
}
